export default {
  interactiveComponent: 'インタラクティブエレメント',
  endPane: {
    title: '終了ページ',
    background: {
      label: '背景を設定',
      opaque: '不透明度',
    },
  },
  jump: {
    title: 'リダイレクトを設定',
    unit: '回',
    endToShop: 'デモ終了後、アプリストアへ自動的にジャンプ',
    clickToShap: '指定したクリック回数後にアプリストアへジャンプ',
  },
  event: {
    label: 'イベント',
    hot: 'クリックエリア',
    eventHand: 'ジェスチャー',
    placeholder: '選択してください',
    click: 'クリック',
    swipe: 'スワイプ',
    longPress: '長押し',
  },
  ivSetting: {
    interactive: 'インタラクション',
    auto: '自動',
    longPress: '長押し',
    method: 'ループモード',
    title: 'インタラクション設定',
    label: 'インタラクションタイプ',
  },
  ivUnit: {
    freeze: 'インタラクションフリーズ',
    loop: 'インタラクションループ',
    longPress: '長押しして再生',
    play: '自動リダイレクト',
  },
  unitTip: {
    freeze: 'ユーザーがクリックするまで再生を一時停止',
    loop: 'ユーザーがクリックするまでループ再生',
    longPress: '長押しで再生、手を離すと一時停止',
  },
  loop: {
    single: '単方向ループ',
    both: '双方向ループ',
  },
  sync: {
    title: '編集同期',
    content:
      '他のノードに同じ動画が含まれている場合、他のノードの編集を現在のノードに同期しますか？選択後は変更できません。',
    sync: '同期',
    noSync: '同期しない',
  },
  guideTip: {
    maskTip:
      'ノードを作成してインタラクティブ動画スクリプトの編集を完了します。',
    knowMsg: '了解',
    firstStep:
      '「Enter」で同じ階層のノードを新規作成し、「Tab」で子ノードを新規作成',
    secondStep: 'プロジェクトに動画をアップロード',
    thirdStep: 'ノードにビデオをドラッグして追加',
    fourthStep:
      'ノード内にインタラクティブ要素を追加して、ビデオの再生を制御できます。',
    fifthStep:
      'デフォルトのインタラクティブリダイレクション、クリックでリダイレクト方法を設定',
  },
  validateTip: {
    banRemoveVideo: '削除できません',
    banRemoveHotArea: 'ノード間のインタラクション設定は削除できません。',
  },
  segment: {
    hand: 'ジェスチャーエリア',
    videoNode: 'ビデオノード',
  },
  sceneErrorType: {
    noVideo: '動画がないため、リソースを追加できません。',
    noSpace: '位置がありません',
    insertFail: '追加に失敗しました',
    segmentNotFound: '目標要素が見つかりません',
    createNodeFail: '対応する要素のノード作成に失敗しました',
  },
  brain: {
    rule: {
      endding: 'エンドカードが設定されました',
    },
    node: {
      enddingname: '終了ページ',
      videoname: 'ビデオノード',
      menu: {
        copy: 'ノードをコピー',
        paste: 'ノードを貼り付け',
        delete: 'ノードを削除',
      },
      unitType: {
        rule: {
          tipsa:
            '複数のクリックエリアが存在し、自動リダイレクトに切り替えることはできません',
          tipsb: 'データが見つからず、切り替えできません',
        },
      },
      emptyNode: {
        title: '動画情報なし',
      },
      video: {
        rule: {
          tipsa: 'エンドカードにはビデオを追加できません',
          tipsc: '自動リダイレクトではノードを追加できません',
        },
      },
      editname: {
        title: 'ノード名',
      },
      sync: {
        tips: '同じビデオを含むノードの編集を同期',
      },
    },
    board: {
      title: 'ストーリーボード',
      action: {
        upload: {
          title: '動画をアップロード',
        },
        localUpload: {
          title: 'アップロード',
        },
        lib: {
          title: 'ライブラリから選択',
        },
      },
      exitFullScreen: 'フルスクリーンを閉じる',
    },
    videoList: {
      title: 'プロジェクトビデオ',
      remove: {
        dialog: {
          title: '追加した動画を削除',
          content:
            'ノードに追加した動画を削除すると、ノード内のすべてのコンテンツも削除されます。',
        },
      },
    },
  },
  resource: {
    uploade: {
      rule: {
        video: {
          tips: 'ビデオパネルに動画リソースをアップロードしてください',
        },
      },
    },
  },
}
